import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const MoreVerticalIcon = React.forwardRef((props, ref) => (_jsxs(Svg, { "data-testid": "MoreVerticalIcon", ...props, ref: ref, viewBox: "0 0 8 24", children: [_jsx("circle", { fill: "currentColor", cx: "4", cy: "4", r: "2" }), _jsx("circle", { fill: "currentColor", cx: "4", cy: "12", r: "2" }), _jsx("circle", { fill: "currentColor", cx: "4", cy: "20", r: "2" })] })));
MoreVerticalIcon.displayName = "MoreVerticalIcon";
